<template>
  <div/>
</template>

<script>
import { mapGetters } from "vuex";
import { localget } from "Utils/storage";
import TrainBookInteractor from 'Domain/use-cases/train-book-interactor'
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      trSearchInfo: "tr/trSearchInfo"
    })
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化页面数据，包括从高德获取的参数
    init() {
      this.getList();
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });

      // 首先初始化页面和客户端的连接
      AmapApp.bridge.ready(() => {
        const data = {
          action: "getAmapAuthCode",
          appId: "2019102468561705",
          scopes: ["auth_base", "auth_user", "auth_phone"]
        };

        // 请求高德授权码，确保在连接就绪后发送
        AmapApp.bridge.send(
          data,
          function(res) {
            alert(`onGetAmapAuthCode:${JSON.stringify(res)}`);
          },
          function(err) {
            console.error("发送消息失败:", err);
          }
        );
      });
    },
    // 获取详情页数据
    async getList() {
      try {
        await this.handleGtParam()
        // 以下数据需要提供
        this.trSearchInfo.fromStationCode = 'VAP'; // 出发地编码
        this.trSearchInfo.toStationCode = 'SHH'; // 目的地编码
        this.trSearchInfo.byTrainDate = '2025-09-01'; // 出发日期yyyy-MM-dd
        this.trSearchInfo.tripType = 1; // 差旅类型： 1因公 2因私
        this.trSearchInfo.trainCode = 'G151'; // 车次编码
        const {
          trainList,
          feeList,
          supplierCode,
          supplierId,
          supplierName,
          sellServiceCharge,
          offline_sellServiceCharge,
          tgOffline_sellServiceCharge,
          slp_sellServiceCharge
        } = await TrainBookInteractor.getTrainList(this.trSearchInfo)
        
        this.trSearchInfo.trainList = trainList
        this.trSearchInfo.feeList = feeList
        this.trSearchInfo.supplierCode = supplierCode
        this.trSearchInfo.supplierId = supplierId
        this.trSearchInfo.supplierName = supplierName
        this.trSearchInfo.PageParameter.sellServiceCharge = sellServiceCharge
        this.trSearchInfo.PageParameter.offline_sellServiceCharge = offline_sellServiceCharge
        this.trSearchInfo.PageParameter.tgOffline_sellServiceCharge = tgOffline_sellServiceCharge
        this.trSearchInfo.PageParameter.slp_sellServiceCharge = slp_sellServiceCharge
        this.$store.commit("tr/trSearchInfo", this.trSearchInfo);
        this.toDetail(trainList[0]);
      } catch (error) {
        throw error
      }
    },
    async handleGtParam() {
      await this.$store.dispatch('tr/getPageParameter').then(() => {
        const queryParam = localget("query_param");
        console.log("queryParam{}", queryParam);
        
        if (queryParam && "gt_123" == queryParam["app_from"]) {
          console.log("this.trSearchInfo111{}", this.trSearchInfo);

          const newSearchInfo = JSON.parse(JSON.stringify(this.trSearchInfo));
          newSearchInfo.fromStationCode = queryParam.from;
          newSearchInfo.toStationCode = queryParam.to;
          newSearchInfo.byTrainDate = queryParam.date;
          newSearchInfo.tripType = 1;
          newSearchInfo.trainCode = 'D974';
          this.$store.commit('tr/trSearchInfo', newSearchInfo);
          console.log("修改后的数据:", newSearchInfo, queryParam.from, queryParam.to, queryParam.date);
        }
      });
    },
    // 跳转到详情页
    toDetail(train) {
      this.trSearchInfo.TrainDetail = train
      this.$toast.clear();
      this.$router.push('/tr/trDetail')
      // this.$router.push({
      //   path: "/tr/trDetail",
      //   query: {
      //     ccsqdId: this.$route.query.ccsqdId,
      //     routeId: this.$route.query.routeId
      //   }
      // });
    },
  }
};
</script>

<style lang="less" scoped></style>
